const gallery = document.querySelectorAll('.js-gallery');

const CURSOR_SHIFT_STRENGTH = 150;
const CURSOR_SMOOTH = 0.05;
const ENTER_DELAY_MS = 250;
const LEAVE_DELAY_MS = 400;
const FADEOUT_DURATION = 0.5;

// Shared mouse position so we can sync on re-enter and avoid jump from (0,0)
const sharedMouse = { x: 0, y: 0 };
document.addEventListener('mousemove', (e) => {
  sharedMouse.x = e.clientX;
  sharedMouse.y = e.clientY;
});

gallery.forEach((elem) => {
  // Use closest so we find .block__product even when ScrollTrigger pin wraps gallery in pin-spacer
  const blockProduct = elem.closest('.product-item')?.querySelector('.block__product') ?? elem.parentNode.querySelector('.block__product');
  const galleryList = elem.querySelectorAll('.gallery__image img, .gallery__image video');

  // Per-image random factors so they shift differently (kinda random)
  const imageFactors = Array.from(galleryList).map(() => ({
    x: 0.4 + Math.random() * 0.6,
    y: 0.4 + Math.random() * 0.6,
    xBias: (Math.random() - 0.5) * 0.3,
    yBias: (Math.random() - 0.5) * 0.3
  }));

  // Create a GSAP timeline for each gallery with a staggered animation on each image
  const tl = gsap.timeline({ paused: true });
  tl.to(galleryList, { scale: 1.75, opacity: 1, duration: .625, stagger: .3125, ease: "power2.out" });

  let cursorTarget = { x: 0, y: 0 };
  let cursorCurrent = { x: 0, y: 0 };
  let raf = null;
  let isHovering = false;
  let isFadingOut = false;
  let enterTimer = null;
  let leaveTimer = null;
  let fadeOutTween = null;

  function tick() {
    cursorCurrent.x += (cursorTarget.x - cursorCurrent.x) * CURSOR_SMOOTH;
    cursorCurrent.y += (cursorTarget.y - cursorCurrent.y) * CURSOR_SMOOTH;
    if (!blockProduct || (!isHovering && !isFadingOut)) return;
    const rect = blockProduct.getBoundingClientRect();
    const cx = rect.left + rect.width / 2;
    const cy = rect.top + rect.height / 2;
    const nx = (cursorCurrent.x - cx) / Math.max(rect.width * 0.5, 1);
    const ny = (cursorCurrent.y - cy) / Math.max(rect.height * 0.5, 1);
    galleryList.forEach((img, i) => {
      const f = imageFactors[i];
      const x = (nx * f.x + f.xBias) * CURSOR_SHIFT_STRENGTH;
      const y = (ny * f.y + f.yBias) * CURSOR_SHIFT_STRENGTH;
      gsap.set(img, { x, y });
    });
    raf = requestAnimationFrame(tick);
  }

  function onMouseMove(e) {
    cursorTarget.x = e.clientX;
    cursorTarget.y = e.clientY;
    if (!raf) raf = requestAnimationFrame(tick);
  }

  function stopCursorTracking() {
    // Don't reset cursor position — keeps re-entry smooth when user leaves and returns quickly
    if (raf) {
      cancelAnimationFrame(raf);
      raf = null;
    }
  }

  function startFadeOut() {
    isHovering = false;
    isFadingOut = true;
    // Explicit fade-out tween (don't kill timeline's opacity/scale tweens or re-enter won't animate)
    if (fadeOutTween) fadeOutTween.kill();
    fadeOutTween = gsap.to(galleryList, {
      opacity: 0,
      scale: 1,
      duration: FADEOUT_DURATION,
      ease: 'power2.in',
      onComplete: () => {
        fadeOutTween = null;
        stopCursorTracking();
        gsap.set(galleryList, { x: 0, y: 0 });
        tl.progress(0);
        tl.pause();
        isFadingOut = false;
        elem.classList.remove('is-leaving');
        document.removeEventListener('mousemove', onMouseMove);
      }
    });
  }

  function transitionBack() {
    stopCursorTracking();
    gsap.set(galleryList, { x: 0, y: 0 });
    tl.reverse();
  }

  const mm = gsap.matchMedia();

  mm.add("(min-width: 750px)", () => {
    if (!blockProduct) return;

    const mediaItems = blockProduct.querySelectorAll('.product__media-item');
    const hoverTargets = mediaItems.length > 0 ? mediaItems : [blockProduct];

    function doEnter() {
      if (isFadingOut) {
        if (fadeOutTween) {
          fadeOutTween.kill();
          fadeOutTween = null;
        }
        gsap.set(galleryList, { opacity: 1, scale: 1.75 });
        isFadingOut = false;
        isHovering = true;
        return;
      }
      gsap.killTweensOf(galleryList, "x,y");
      cursorTarget.x = sharedMouse.x;
      cursorTarget.y = sharedMouse.y;
      isHovering = true;
      tl.play();
      document.addEventListener('mousemove', onMouseMove);
      if (!raf) raf = requestAnimationFrame(tick);
    }

    function onEnter() {
      if (leaveTimer) {
        clearTimeout(leaveTimer);
        leaveTimer = null;
        elem.classList.remove('is-leaving');
      }
      if (isFadingOut) {
        doEnter();
        return;
      }
      if (isHovering) return;
      if (enterTimer) clearTimeout(enterTimer);
      enterTimer = setTimeout(() => {
        enterTimer = null;
        doEnter();
      }, ENTER_DELAY_MS);
    }

    function onLeave() {
      if (enterTimer) {
        clearTimeout(enterTimer);
        enterTimer = null;
      }
      if (isFadingOut) return;
      if (!isHovering) return;
      if (leaveTimer) clearTimeout(leaveTimer);
      elem.classList.add('is-leaving');
      leaveTimer = setTimeout(() => {
        leaveTimer = null;
        startFadeOut();
      }, LEAVE_DELAY_MS);
    }

    hoverTargets.forEach((target) => target.addEventListener('mouseenter', onEnter));
    blockProduct.addEventListener('mouseleave', onLeave);
  });

  mm.add("(max-width: 749px)", () => {
    ScrollTrigger.create({
      trigger: elem,
      start: "top bottom",
      onEnter: () => tl.play(),
      onLeaveBack: () => transitionBack(),
      toggleActions: "play none none reverse"
    });
  });
});